/**
 * DEV-only mount for Playwright hermetic navigation with location.state.
 * Production builds: `import.meta.env.DEV` is false — lazy chunk omitted (no hook, no bundle leak).
 * Mirrors ToastHost / ErrorIsolationProbe non-prod E2E wiring pattern.
 */
import { lazy, Suspense, type ReactNode } from 'react';

const E2eNavigateBridgeLazy = import.meta.env.DEV
  ? lazy(() =>
      import('../test/e2e/e2eNavigateBridge.js').then((mod) => ({
        default: mod.E2eNavigateBridge,
      })),
    )
  : null;

export function E2eNavigateBridgeMount(): ReactNode {
  if (E2eNavigateBridgeLazy === null) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <E2eNavigateBridgeLazy />
    </Suspense>
  );
}
